import { makeStyles } from '@mui/styles'
import ErrorIcon from '@mui/icons-material/Error'
import { Theme } from '@mui/material/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    color: theme.palette.error.main,
  },
  icon: {
    marginTop: '0px',
    display: 'inline-flex',
    verticalAlign: 'top',
  },
}))

export const ErrorMessageContainer: React.FC<{
  messages?: string[]
}> = (props) => {
  const classes = useStyles()
  const { messages } = props

  return (
    <div>
      {(messages || []).map((message) => {
        return (
          <div className={classes.container}>
            <ErrorIcon className={classes.icon} />
            <span data-test="error-message">{message}</span>
          </div>
        )
      })}
    </div>
  )
}
